import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';
import { Star } from 'lucide-react';

// Repräsentative 5-Sterne Google-Bewertungen (Original DE).
const REVIEWS = [
  { name: 'Mehmet K.', text: 'Absolut authentische türkische Küche! Die Linsensuppe und das Kavurma waren fantastisch. Fühlt sich an wie zu Hause bei Oma.' },
  { name: 'Sarah L.', text: 'Bestes türkisches Essen in Charlottenburg. Frisch, lecker und sehr freundlicher Service. Komme immer wieder gerne!' },
  { name: 'Ahmet Y.', text: 'Die Pide sind der Wahnsinn und der Steinofen macht den Unterschied. Große Portionen zu fairen Preisen.' },
  { name: 'Julia M.', text: 'Gemütliches Ambiente, super nette Bedienung und das Essen schmeckt wie in der Türkei. Absolute Empfehlung!' },
  { name: 'Can D.', text: 'Endlich echtes Ev yemeği in Berlin! Kuru Fasulye mit Reis war perfekt. Danke für die Gastfreundschaft.' },
  { name: 'Laura B.', text: 'Frische Zutaten, hausgemachte Gerichte und ein tolles Baklava zum Nachtisch. 5 Sterne verdient!' },
  { name: 'Emre T.', text: 'Sehr sauber, schnelle Bedienung und die Suppen sind ein Traum. Mein neuer Lieblingsladen.' },
  { name: 'Nina S.', text: 'Wunderbares Essen und herzliche Menschen. Das Tagesmenü ist jeden Cent wert.' },
];

const ReviewCard = ({ r }) => (
  <div className="w-[300px] flex-shrink-0 bg-white/5 border border-white/10 rounded-2xl p-5 mx-3 backdrop-blur-sm">
    <div className="flex items-center gap-1 mb-2">
      {[0, 1, 2, 3, 4].map((i) => (
        <Star key={i} className="w-4 h-4 fill-[#FFC107] text-[#FFC107]" />
      ))}
    </div>
    <p className="text-white/80 text-sm leading-relaxed mb-3 line-clamp-4">“{r.text}”</p>
    <div className="flex items-center gap-2">
      <span className="w-7 h-7 rounded-full bg-[#d4af37] text-black text-xs font-bold flex items-center justify-center">
        {r.name.charAt(0)}
      </span>
      <span className="text-white font-semibold text-sm">{r.name}</span>
    </div>
  </div>
);

const ReviewsMarquee = () => {
  const { language } = useLanguage();
  const t = translations[language];
  const loop = [...REVIEWS, ...REVIEWS];

  return (
    <div className="mt-16" data-testid="reviews-marquee">
      <div className="text-center mb-8">
        <h3 className="text-3xl md:text-4xl font-bold text-white mb-2" style={{ fontFamily: "'Crimson Text', serif" }}>
          {t.reviews_title}
        </h3>
        <p className="text-white/70">{t.reviews_subtitle}</p>
      </div>
      <div className="relative overflow-hidden">
        {/* fade edges */}
        <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-16 bg-gradient-to-r from-black to-transparent z-10"></div>
        <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-16 bg-gradient-to-l from-black to-transparent z-10"></div>
        <div className="marquee-track py-2">
          {loop.map((r, i) => (
            <ReviewCard key={i} r={r} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ReviewsMarquee;
